'use strict';

module.exports = Object.freeze({
  MARS_AGENT: 'mars',
  MERCURY_AGENT: 'mercury',
  HOMEKIT_AGENT: 'homekit',
  ZWAVE_AGENT: 'zwave',
});
